var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderIcon = function SvgFolderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 5")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category-inside-view---subcategories-Copy-7",
    transform: "translate(-214.000000, -161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(214.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#75B753",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3376954,11 C17.4596342,11 17.5774041,11.0413639 17.6712032,11.1165251 L20.6529715,13.5221879 L28.932303,13.5221879 C30.0818628,13.5221879 31.0167269,14.427149 31.0167269,15.5399383 L31.0167269,17.5576887 L30.9287658,17.5571255 C30.9858728,17.7337326 31.0167269,17.9221917 31.0167269,18.1179231 L31.0167269,27.1801191 C31.0167269,28.1852116 30.2070287,29 29.1962745,29 L10.8204524,29 C9.8150443,29 9,28.1861129 9,27.1801191 L9,18.1179231 C9,17.922367 9.03065163,17.7340151 9.087472,17.5574668 L9,17.5576887 L9,13.0177504 C9,11.904961 9.93486409,11 11.0844238,11 L17.3376954,11 Z",
    id: "Combined-Shape-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "+-copy-2",
    fontFamily: "ProximaNova-Black, Proxima Nova",
    fontSize: 18.1818182,
    fontWeight: 700,
    fill: "#75B753"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.3636364,
    y: 27
  }, "+"))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folderIcon.7c306360.svg";
export { ForwardRef as ReactComponent };